// Archivo limpiado: redundancias eliminadas y uso real mantenido
import * as React from 'react';
import { connect } from 'react-redux';
import {
    setFiltroPublicacion,
    fetchPublicaciones,
    fetchVariaciones,
    fetchMarcas,
    fetchCategorias
} from '../../../actions/publicacionesActions';
import { fetchExportarPublicacionesApi } from '../../../api/axios';
import { fetchSellers } from '../../../actions/sellersActions';
import { fetchTiposPublicacionAdm } from '../../../actions/tiposPublicacionActions';
import PublicacionesFilter from '../../Publicaciones/Components/PublicacionesFilter';
import BigSpinner from "../../General/BigSpinner";
import MiniSpinner from "../../General/MiniSpinner";
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import { toast } from 'react-toastify';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';

class ExportarPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOptions: { idSeller: null },
            datosExcelFormateados: null,
            listaTipoPublicacionCargada: false,
            hideSpinner: true,
            cantidadPublicaciones: 0,
            excelBase64: null,
            loadingExport: false,
        };
    }

    componentDidMount() {
        this.props.publicaciones.cantidadTotal = 0;
        this.cargarTipoPublicacionLista();
        this.props.fetchVariaciones();
        this.onFetchFilterOptions("");
    }

    onFetchFilterOptions = (descripcion) => {
        this.props.fetchCategorias(descripcion);
        this.props.fetchMarcas(descripcion);
        this.props.fetchSellers({ descripcion }, "0", "0");
    };

    chargeFilterOptions = (options) => {
        this.setState({ datosExcelFormateados: null, filterOptions: options });
        this.props.setFiltroPublicacion(options);
    };

    cargarTipoPublicacionLista = () => {
        if (!this.state.listaTipoPublicacionCargada) {
            const params = this.props.userType.isCategory || this.props.userType.isAdminMod
                ? { params: { "CantidadPagina": 100 } }
                : this.props.idSeller;
            this.props.fetchTiposPublicacionAdm(params);
            this.setState({ listaTipoPublicacionCargada: true });
        }
    };

    busquedaParaDescargarExcel = () => {
        this.setState({ datosExcelFormateados: null, hideSpinner: false });

        let idSeller = this.props.idSeller;
        if ((this.props.userType.isCategory || this.props.userType.isAdminMod) && this.props.filtroPublicacion.idSeller !== "") {
            idSeller = parseInt(this.props.filtroPublicacion.idSeller);
        }

        const f = this.props.filtroPublicacion;

        this.requestParaExportar({
            idSeller: isNaN(parseInt(idSeller)) ? null : parseInt(idSeller),
            fechaPubDesde: f.fechaPubDesde,
            fechaPubHasta: f.fechaPubHasta,
            categoria: isNaN(parseInt(f.categoria)) ? null : parseInt(f.categoria),
            marca: isNaN(parseInt(f.marca)) ? null : parseInt(f.marca),
            estado: f.estado,
            skuSeller: f.skuSeller,
            skuMarket: f.skuMarket,
            sinStock: f.sinStock === "" ? null : f.sinStock
        });
    };

    requestParaExportar = async (request) => {
        this.setState({ loadingExport: true, hideSpinner: false });

        try {
            const req = await fetchExportarPublicacionesApi(request);
            if (req?.excel && typeof req.cantidadPublicaciones === 'number') {
                this.setState({
                    cantidadPublicaciones: req.cantidadPublicaciones,
                    hideSpinner: true,
                    excelBase64: req.excel
                });
            } else {
                toast.warn('No se encontraron publicaciones para exportar');
                this.setState({ hideSpinner: false })
            }
        } catch(err) {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error('No se pudo preparar los datos para exportar');

                this.setState({ hideSpinner: true, cantidadPublicaciones: 0 });
        } finally {
            this.setState({ loadingExport: false });
        };
    };

    descargarArchivoExcel = (base64Data, nombreArchivo) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        const sizeArray = JSON.stringify(this.state.datosExcelFormateados);
        return (
            <section className="container" role="search">
                <div className="row page-titles">
                    <div className="col-12">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-12 col-md-auto">
                                <h4 className="text-themecolor color-rojo-megatone">Publicaciones</h4>
                            </div>
                            <div className="col-12 col-md-auto">
                                <div className="row justify-content-center">
                                    <div className="col-auto button-group text-right d-block">
                                        {(!this.state.hideSpinner && sizeArray !== "[]") && <MiniSpinner />}
                                    </div>
                                    <div className="col-12 col-md-auto button-group text-right">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-green"
                                            onClick={() => {
                                                if (this.state.excelBase64) {
                                                    this.descargarArchivoExcel(this.state.excelBase64, `Publicaciones.xlsx`);
                                                } else {
                                                    toast.warn("No hay datos para descargar");
                                                }
                                            }}
                                            disabled={!this.state.hideSpinner || this.state.cantidadPublicaciones === 0}
                                        >
                                            Descargar {this.state.cantidadPublicaciones || 0} publicaciones
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PublicacionesFilter
                    filtro={this.props.emptyFiltro.publicaciones === false ? this.props.filtroPublicacion : ""}
                    setInitialPage={() => {}}
                    chargeFilterOptions={this.chargeFilterOptions}
                    allowSearchBySeller={this.props.userType.isCategory || this.props.userType.isAdminMod}
                    requestParaExportar={this.requestParaExportar}
                    onClearCantidad={() => this.setState({ cantidadPublicaciones: 0, excelBase64: null })}
                    shouldFetchOnClear={false}
                    loadingExport={this.state.loadingExport}
                />
                {this.props.loadingPublicaciones && <BigSpinner />}
            </section>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    publicaciones: state.publicaciones.publicaciones,
    filtroPublicacion: state.publicaciones.filtroPublicaciones,
    cantidadTotal: state.publicaciones.publicaciones.cantidadTotal,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    setFiltroPublicacion,
    fetchTiposPublicacionAdm,
    fetchPublicaciones,
    fetchCategorias,
    fetchVariaciones,
    fetchMarcas,
    fetchSellers
})(ExportarPublicaciones);